import React from "react";
import categorias, { infoServicio } from "modAws/CatalogoAws";
import { FILAS, MAX_COMPARAR, columnas } from "../aprende/comparar";
import { Nivel } from "../piezas";

// Comparador lado a lado: hasta tres servicios en columnas, con lo que cuesta, cuando conviene y con que se conectan.
const Comparar = ({ ids, onCambiar, onServicio }) => {
    const cols = columnas(ids);
    const set = (k, id) => { const n = [...ids]; if (id) n[k] = id; else n.splice(k, 1); onCambiar(n.filter(Boolean)); };
    const valor = (f, v) => {
        if (f.id === "nivel") return <Nivel nivel={v} />;
        if (Array.isArray(v)) return f.id === "con" || f.id === "objetos"
            ? <div className="d-flex flex-wrap gap-1">{v.map(x => <span key={x} className="badge text-bg-light fw-normal">{x}</span>)}</div>
            : <ul className="mb-0 ps-3">{v.map((x, k) => <li key={k}>{x}</li>)}</ul>;
        return v;
    };
    return (
        <div className="card mb-3" style={{ borderTop: "4px solid #00A1C9" }} data-guia="comparar">
            <div className="card-body">
                <div className="text-muted small mb-1"><i className="fa fa-columns me-1" />Comparador</div>
                <h4>Compara servicios lado a lado</h4>
                <p>Elige hasta {MAX_COMPARAR} servicios para ver en qué se parecen y en qué se diferencian.</p>
                <div className="row g-2 mb-3">
                    {Array.from({ length: Math.min(MAX_COMPARAR, cols.length + 1) }, (_, k) => (
                        <div className="col-md-4" key={k}>
                            <select className="form-select form-select-sm" value={ids[k] || ""} onChange={e => set(k, e.target.value)} aria-label={`Servicio ${k + 1} a comparar`}>
                                <option value="">{ids[k] ? "Quitar este servicio" : "Agregar un servicio…"}</option>
                                {categorias.map(c => <optgroup key={c.title} label={c.title}>{c.servicios.map(s => <option key={s.id} value={s.id} disabled={ids.includes(s.id) && ids[k] !== s.id}>{s.title}</option>)}</optgroup>)}
                            </select>
                        </div>
                    ))}
                </div>
                {cols.length < 2 ? <div className="text-muted">Elige al menos dos servicios para compararlos.</div> : (
                    <div className="table-responsive">
                        <table className="table table-bordered align-top">
                            <thead><tr><th style={{ width: 150 }} />{cols.map(c => (
                                <th key={c.id} style={{ borderTop: `4px solid ${c.color}` }}><button className="btn btn-link p-0 fw-bold text-body text-decoration-none" onClick={() => onServicio && onServicio(c.id)}><i className={`${infoServicio(c.id).servicio.icon} me-1`} style={{ color: c.color }} />{c.titulo}</button></th>
                            ))}</tr></thead>
                            <tbody>
                                {FILAS.map(f => <tr key={f.id}><th className="small text-muted">{f.titulo}</th>{cols.map(c => <td key={c.id}>{valor(f, c.filas[f.id])}</td>)}</tr>)}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Comparar;
